import { makeStyles } from '@material-ui/core';

const useDocumentsRendererStyles = makeStyles((theme) => {
  return ({
    documentRequirementWrapper: {
      margin: '20px 0px'
    },
    documentRequirementTitle: {
      marginBottom: '10px'
    },
    noDocsMsg: {
      marginTop: '5px',
      marginLeft: '20px'
    },
    documentWrapper: {
      display: 'flex'
    },
    documentDetailsWrapper: {
      display: 'flex', 
      alignItems: 'center'
    },
    removeDocLoadingWrapper: {
      '& > div:first-child': {
        marginTop: '0px'
      }
    },
    downloadBtn: {
      margin: '5px',
      padding: '0px'
    },
    removeBtn: {
      color: 'var(--teal-blue)',
      fontSize: '14px',
      lineHeight: '22px',
      fontWeight: 500,
      cursor: 'pointer'
    },
    deleteDialogBtn: {
      color: 'var(--white)',
      backgroundColor: 'var(--teal-blue)',
      '&:hover': {
        color: 'var(--white)',
        backgroundColor: 'var(--teal-blue)',
      }
    },
    deleteConfirmationTitleIcon: {
      color: 'var(--fire-brick-red)',
      marginBottom: '-10px'
    },
    dialogContentWrapper: {
      overflow: 'hidden'
    },
    paper: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(3),
    },
    dangerText: {
      color: '#ff4d4f'
    },
    uploadHeaders: {
      fontWeight:500,
      color: 'var(--neutrals-black)'
    },
    warningText: {
      color: '#ff9800'
    },
    fileStatus: {
      color: 'var(--dark-green)',
      verticalAlign: 'middle',
      marginRight: 5,
      marginTop: 5
    },
    fileLabel: {
      color: 'var(--neutrals-black)'
    },
    gridItem: {
      padding: '0 8px !important'
    },
    endAdornmentWrapper: {
      marginLeft: '2px',
      zIndex: 1,
      cursor: 'auto',
  
      '& svg': {
        color: 'var(--teal-blue)',
        height: '20px',
        width: '20px',
      }
    },
    sectionDescription1: {
      alignSelf: 'stretch',
      width: '730px',      
      color: 'var(--neutrals-grey-900, #212121)',
      fontFamily: 'Roboto, sans-serif',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '22px',
      marginTop: '8px',
      marginBottom: '8px',
      whiteSpace: 'normal',
      wordBreak: 'keep-all',
      overflowWrap: 'normal',
    }
  });
});

export default useDocumentsRendererStyles;
